// extracted by mini-css-extract-plugin
export default {"wrapper":"PostPage_wrapper__YGUah"};